import CourseCard from '../home/CoursesSection/CourseCard';

export default function TeacherCoursesSection({ courses }) {
  return (
    <section className="bg-[#1B1B1B] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-2xl font-bold text-white sm:text-[32px]">Expand Your Knowledge</h2>
        <ul className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {courses.map((course) => (
            <li key={course.id}>
              <CourseCard course={course} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
